const translations = {
  nav_about: "About",
  nav_activities: "Activities",
  nav_vision: "Vision",
  nav_join: "Join Us",
  lang_en: "EN",
  lang_ja: "JP",

  hero_label: "Connecting across companies to create new opportunities",
  hero_title_line1: "NJ-Japan Business Hub",
  hero_title_line2: "A Business Hub for Professionals",
  hero_subtitle: "A community for business professionals working at Japanese companies in New Jersey.",
  hero_cta: "Join the Community",
  hero_scroll: "Learn More",

  bg_label: "Background",
  bg_title: "The Challenge We All Face",
  bg_text1: "New Jersey is home to many Japanese companies. However, unlike cities such as New York or Los Angeles, opportunities to connect across companies and industries remain limited.",
  bg_text2: "Even while working in the same region, there are few chances to interact with professionals from other organizations.",
  bg_question: "Have you ever felt that way?",

  community_label: "About This Community",
  community_title: "Connecting Beyond Company Boundaries",
  community_text: "This community is designed for professionals working at Japanese companies in New Jersey to connect beyond company boundaries, roles, and nationalities. Rather than being limited to a specific industry or function, it aims to create a space where people in the same region can naturally interact and build meaningful relationships.",

  value_label: "Value Proposition",
  value_title: "What You Will Gain",
  value_item1_title: "Cross-Company Networking",
  value_item1_text: "Connect with professionals from other Japanese companies in the region and expand your professional circle.",
  value_item2_title: "Shared Experiences",
  value_item2_text: "Share experiences and challenges unique to Japanese organizations operating in the U.S.",
  value_item3_title: "Fresh Perspectives",
  value_item3_text: "Gain new insights through open discussion and knowledge exchange beyond your daily work.",
  value_item4_title: "Career Opportunities",
  value_item4_text: "Discover new business and career opportunities through genuine human connections.",

  activities_label: "Activities",
  activities_title: "How We Connect",
  activities_item1_title: "Regular Meetups",
  activities_item1_text: "In-person or virtual gatherings to connect with fellow professionals in a relaxed setting.",
  activities_item2_title: "Small Group Sessions",
  activities_item2_text: "Focused discussion sessions in small groups where ideas and experiences flow freely.",
  activities_item3_title: "Online Community",
  activities_item3_text: "Ongoing interaction and knowledge sharing through our Slack community platform.",
  activities_note: "Our focus is on creating an environment where conversations happen naturally and relationships can develop over time.",

  vision_label: "Vision",
  vision_title: "Building Lasting Connections",
  vision_text1: "We begin by building connections among professionals in New Jersey.",
  vision_text2: "Over time, the community aims to evolve into a platform that enables collaboration, knowledge sharing, and new business opportunities.",

  organizer_label: "Organizer",
  organizer_title: "Organized by Cornerstone Strategy LLC",
  organizer_text: "Cornerstone Strategy provides coaching and HR consulting services to Japanese companies operating in or expanding into the United States, supporting organizational and talent development.",
  organizer_founder_label: "Founder & CEO",
  organizer_founder_name: "Shinsuke Kiyono",
  organizer_founder_bio: "With experience at Accenture and Deloitte Tohmatsu Consulting, he has worked on numerous projects in organizational and talent development. Currently based in New Jersey, he supports Japanese companies in their global expansion.",
  organizer_mission: "This initiative is driven by the belief that meaningful connections can lead to valuable opportunities and long-term growth.",

  cta_label: "Join Us",
  cta_title: "Become a Member",
  cta_text: "This community is an open platform for professionals working at Japanese companies in New Jersey to connect and engage across organizations and roles. Anyone who is interested is welcome to join. Participation is currently free. Details may evolve as the community grows.",
  cta_subtitle: "Join the community.",
  cta_form_name: "Full Name",
  cta_form_email: "Email Address",
  cta_form_company: "Company Name",
  cta_form_role: "Role / Title",
  cta_form_message: "Message (Optional)",
  cta_form_message_placeholder: "Feel free to share anything — your interests, questions, or what you hope to gain from this community.",
  cta_form_link_desc: "Click the button below to complete your registration via our online form.",
  cta_form_submit: "Submit Registration",
  cta_form_success: "Thank you! We will be in touch shortly.",
  cta_form_error: "Something went wrong. Please try again.",
  cta_form_char_limit: "Maximum 500 characters",

  footer_tagline: "Coaching & Consulting",
  footer_copyright: "© 2026 Cornerstone Strategy LLC. All rights reserved.",
  footer_contact: "Contact Us",
  footer_website: "Visit Cornerstone Strategy",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Use",
};

export default translations;
